import { Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import ModalLayout from "../../../../../components/ModalLayout";
import CustomBottomSheet from "../../../../../components/CustomBottomSheet";
import InfoCircle from "../../../../../../media/images/icons/info-circle";
import { theme } from "../../../../../../themes";
import { blueGrey, grey } from "@mui/material/colors";
import DolorGreen from "../../../../../../media/images/icons/dolor-green";
import CustomButton from "../../../../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { addCommas } from "@persian-tools/persian-tools";
import BottomSheetLayout from "../../../../../components/BottomSheetLayout";
import { useAppSelector } from "../../../../../../hooks/useRedux";

interface Props {
  loading?: boolean;
  cost: string;
  open: boolean;
  onDismiss: () => void;
  onOk: () => void;
}
export default function ApproveChackinBotomSheet(props: Props) {
  const { onDismiss, open, onOk, cost } = props;

  const theme = useTheme();

  const { stock } = useAppSelector((state) => state.user);

  return (
    <BottomSheetLayout open={open} onDismiss={onDismiss}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          padding: "4px 4px 12px 4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            border: "1px solid",
            borderColor: blueGrey[100],
            padding: "8px",
            borderRadius: "8px",
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary[50],
              paddingY: "6px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              justifyContent: "center",
            }}
          >
            <InfoCircle size={28} color={theme.palette.primary.main} />

            <Typography
              sx={{
                color: "primary.main",
                fontSize: "16px",
                fontWeight: "700",
              }}
            >
              هزینه اعلام حضور
            </Typography>
          </Box>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            هزینه اعلام حضور برای شما مبلغ {addCommas(cost)} ریال می‌باشد، در
            صورت تایید، این هزینه از کیف پول شما کسر می‌گردد.
          </Typography>
          <Box
            sx={{
              border: "1px solid",
              borderColor: theme.palette.secondary[600],
              backgroundColor: theme.palette.secondary[50],

              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 1,
              borderRadius: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <DolorGreen color={theme.palette.secondary[600]} />
              <Typography
                sx={{
                  color: theme.palette.secondary[600],
                  fontSize: "16px",
                  fontWeight: "700",
                }}
              >
                هزینه اعلام حضور:
              </Typography>
            </Box>
            <Typography
              sx={{
                color: theme.palette.secondary[600],
                fontSize: "18px",
                fontWeight: "700",
              }}
            >
              {addCommas(cost)} ریال
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "16px",
              }}
            >
              موجودی شما:
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  color: theme.palette.secondary.main,
                  fontSize: "18px",
                  fontWeight: "700",
                }}
              >
                {addCommas(stock || 0)}
              </Typography>
              <Typography
                sx={{
                  color: theme.palette.secondary.main,
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                ریال
              </Typography>
            </Box>
          </Box>
        </Box>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "700",
            textAlign: "center",
          }}
        >
          مایل به کسر هزینه و اعلام حضور هستید؟
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <CustomButton
            // loading={loading}
            onClick={() => onOk()}
            flex={1}
            flexDirection="row"
            title="تایید و  ثبت اعلام حضور"
            justifyContent="center"
            bgColor="primary.main"
            fSize="16px"
            px="10px"
            py="14px"
            borderRadius="10px"
            // icon1={<CheckCircle size={32} />}
          />
          <CustomButton
            // loading={loading}
            onClick={() => onDismiss()}
            flexDirection="row"
            title="انصراف"
            borderColor="primary.main"
            textColor="primary.main"
            justifyContent="center"
            bgColor="#fff"
            fSize="16px"
            px="10px"
            py="14px"
            borderRadius="10px"
            // icon1={<CheckCircle size={32} />}
          />
        </Box>
      </Box>
    </BottomSheetLayout>
  );
}
